import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import BoxedContainer from '../layouts/BoxedContainer';

export default function ContactCards({ data }) {
  const { cardsList } = data;
  return (
    <section
      className="bg-white lg:pt-[100px] pt-[80px] lg:pb-[240px] pb-[80px] clip-right-top
      relative z-5 "
    >
      <BoxedContainer className="boxed">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-wrap 3xl:gap-x-[32px] gap-x-[16px] gap-y-[20px]"
        >
          {isEmpty(cardsList) ||
            cardsList.map((card) => (
              <div
                key={card.title}
                className="w-full sm:w-[calc(50%-8px)] xl:w-[calc(25%-12px)] bg-bg-1 3xl:py-[57px]
                lg:py-[40px] 3xl:w-[calc(25%-24px)]
                py-[30px] 3xl:px-[40px]
                px-[25px] md:min-h-[314px] min-h-[250px] flex flex-col lg:gap-y-9 gap-y-4"
              >
                <h3 className="uppercase font-roboto-condensed-bold text-[23px] leading-[46px]">
                  {card.content.title}
                </h3>
                <div
                  className="li-child:text-bg-7 li-child:font-roboto-regular li-child:3xl:text-base
                  li-child:text-[14px] li-child:leading-7 first:li-child:w-1/5
                  first:li-child:min-w-[3.5rem] li-child:truncate
                  ul-child:flex ul-child:flex-nowrap ul-child:gap-x-4 ul-child:gap-y-2
                  p-child:text-bg-7 p-child:font-roboto-regular p-child:3xl:text-base
                  p-child:text-[14px] p-child:leading-7"
                  dangerouslySetInnerHTML={{ __html: card.content.infoText }}
                />
              </div>
            ))}
        </motion.div>
      </BoxedContainer>
    </section>
  );
}
